import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { lightGreen } from '@mui/material/colors';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';

import { isProductionEnvironment } from '../../utils/utils';

interface NFCMockFormProps {
    onSubmit: (result: React.SetStateAction<string | null>) => void;
}

export const NFCMockForm: React.FC<NFCMockFormProps> = ({ onSubmit }) => {
    const [rfid, setRfid] = useState<string>('');

    if (isProductionEnvironment()) {
        return null;
    }

    return (
        <Card style={{ background: lightGreen[50] }}>
            <CardContent>
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                        if (rfid) {
                            onSubmit(rfid);
                        }
                    }}
                >
                    <Box my={2}>
                        <TextField
                            id="inputMockRFID"
                            label="Mock RFID"
                            onChange={({ target }) => {
                                setRfid(target.value.trim());
                            }}
                        />
                    </Box>
                    <Button id="submitMockRFID" type="submit" variant="contained">
                        Submit mock RFID
                    </Button>

                    <p>
                        <code>Note: This form is visible only in the development environment.</code>
                    </p>
                </form>
            </CardContent>
        </Card>
    );
};
